'use client'

import { AIGenerationLoading } from '@/components/ai/ai-generation-loading'

type RecommendationGenerationLoadingProps = {
  previewLoop?: boolean
}

export function RecommendationGenerationLoading({
  previewLoop = false,
}: RecommendationGenerationLoadingProps) {
  return <AIGenerationLoading scope="recommendation" previewLoop={previewLoop} />
}
